import { useEffect, useState } from 'react';
import { ORBIT_BASE_HEIGHT, ORBIT_BASE_WIDTH } from './orbitGeometry';

// Historical vertical margin; kept so landscape screens render exactly as before.
const MARGIN_SCREEN_RATIO = 0.15;
const MIN_SCALE = 0.3;

export const computeOrbitScale = (width, height) => {
  const fitByHeight = height / ORBIT_BASE_HEIGHT - MARGIN_SCREEN_RATIO;
  // The outermost tiles end ~4% inside the SVG edge, so fitting the full width leaves a gutter.
  const fitByWidth = width / ORBIT_BASE_WIDTH;
  return Math.max(MIN_SCALE, Math.min(fitByHeight, fitByWidth));
};

const readViewportScale = () => computeOrbitScale(window.innerWidth, window.innerHeight);

/**
 * Scale factor that keeps the splash orbit inside the viewport on both axes.
 * Recomputed on window resize and orientation change.
 */
const useOrbitScale = () => {
  const [scale, setScale] = useState(readViewportScale);

  useEffect(() => {
    const handleResize = () => setScale(readViewportScale());
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return scale;
};

export default useOrbitScale;
